import api from '../utils/api';

// Função para buscar códigos bloqueados com paginação e busca
export const getCodBloqueados = async (search, currentPage, itemsPerPage) => {
    const limitDefault = itemsPerPage || 10;

    try {
        const token = localStorage.getItem('token');
        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`;

        let url = `/codbloqueados?page=${currentPage}&limit=${limitDefault}`;
        if (search) {
            url += `&search=${search}`;
        }

        const data = await api.get(url).then((response) => response.data);
        return data;
    } catch (error) {
        return null;
    }
};

// Função para buscar um código por ID
export const getCodBloqueadoById = async (id) => {
    try {
        const token = localStorage.getItem('token');
        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`;

        const data = await api.get(`/codbloqueados/${id}`).then((response) => response.data);
        return data;
    } catch (error) {
        return null;
    }
};

// Função para criar um novo código bloqueado
export const createCodBloqueado = async ({ codigo, referencia, descricao, fornecedor }) => {
    try {
        const token = localStorage.getItem('token');
        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`;

        const data = await api
            .post('/codbloqueados/create', { codigo, referencia, descricao, fornecedor })
            .then((response) => response.data);
        return data;
    } catch (error) {
        return null;
    }
};

// Função para remover um código por ID
export const removeCodBloqueado = async (id) => {
    try {
        const token = localStorage.getItem('token');
        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`;

        const data = await api.delete(`/codbloqueados/${id}`).then((response) => response.data);
        return data;
    } catch (error) {
        return null;
    }
};

export const importarCodigosBloqueados = async (codigos) => {
    try {
        const token = localStorage.getItem('token');
        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`;

        const data = await api
            .post('/codbloqueados/importacao-massiva', { codigos })
            .then((response) => response.data);
        return data;
    } catch (error) {
        return null;
    }
};

// Função para ativar um código bloqueado
export const activateCodBloqueado = async (id) => {
    try {
        const token = localStorage.getItem('token');
        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`;

        const data = await api.patch(`/codbloqueados/activate/${id}`).then((response) => response.data);
        return data;
    } catch (error) {
        return null;
    }
};

// Função para desativar um código bloqueado
export const deactivateCodBloqueado = async (id) => {
    try {
        const token = localStorage.getItem('token');
        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`;

        const data = await api.patch(`/codbloqueados/deactivate/${id}`).then((response) => response.data);
        return data;
    } catch (error) {
        return null;
    }
};

// Verifica se um código está bloqueado. Busca exata por codSap no backend, em
// vez da busca textual da tela — que varria 15 mil documentos com 4 $regex para
// responder uma pergunta de sim ou não.
export const verificarBloqueio = async (codSap) => {
    try {
        const token = localStorage.getItem('token');
        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`;

        const { data } = await api.get(`/codbloqueados/bloqueado?codsap=${encodeURIComponent(codSap)}`);
        return data;
    } catch (error) {
        return null;
    }
};

// Serviço centralizado
const CodBloqueadosService = {
    getCodBloqueados,
    verificarBloqueio,
    getCodBloqueadoById,
    createCodBloqueado,
    removeCodBloqueado,
    importarCodigosBloqueados,
    activateCodBloqueado,
    deactivateCodBloqueado,
};

export default CodBloqueadosService;
